module.exports = __webpack_public_path__ + "img/farming_new.d78f8d9a.png";